<div
  class="container-filter__padding"
  matMenuContent
  (click)="$event.stopPropagation()"
>
  <mat-radio-group
    [ngModel]="filtroPeriodo"
    (ngModelChange)="onFiltroChange($event)"
    disabledInteractive
  >
    <div class="item-filter">
      <div class="lista">
        @for(periodo of periodoOptions; track periodo){
        <div class="item">
          <mat-radio-button
            class="filter-radio-margin"
            disableRipple
            color="primary"
            [value]="periodo.value"
            labelPosition="before"
            (click)="onRadioClick($event, periodo.value)"
          >
            <div style="position: absolute; width: 90%; height: 7%; cursor: pointer;"></div>
            <span class="filter-text" style="cursor: pointer">{{
              periodo.viewValue
            }}</span>
          </mat-radio-button>
        </div>
        }
      </div>
    </div>
  </mat-radio-group>
</div>
